import CustomText from '@components/shared/CustomText';
import StepCounter from '@features/DocViewer/Steps/StepCounter';
import clsx from 'clsx';

import useGetPaginatedSignatures from '@hooks/useGetPaginatedSignatures';

import { DOC_VIEWER_STEPS } from '@shared/constants';
import { useEffect, useMemo, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import VerifySignee from './Steps/VerifySignee';
import EnterMobileAndEmail from './Steps/EnterMobileAndEmail';
import Docs from './Steps/Docs';

import styles from './DocViewer.module.scss';
import { useDocViewerContext } from '../../context/DocViewerContext';

const DocViewer = () => {
  const { userID } = useDocViewerContext();

  const [currentStep, setCurrentStep] = useState(
    DOC_VIEWER_STEPS.mobileAndEmail,
  );
  const formMethods = useForm();
  const { getValues } = formMethods;

  const { data, hasPrevious, hasNext, fetchPage, changeSort, sort, isLoading } =
    useGetPaginatedSignatures(userID, {
      enabled: DOC_VIEWER_STEPS.docs.id === currentStep.id,
    });

  const lastCountRef = useRef();

  useEffect(() => {
    lastCountRef.current = data?.total;
  }, [data?.total]);

  const totalCount = useMemo(
    () => data?.total || lastCountRef.current,
    [data?.total],
  );

  useEffect(() => {
    if (userID && currentStep !== DOC_VIEWER_STEPS.docs) {
      setCurrentStep(DOC_VIEWER_STEPS.docs);
    }
  }, [userID, currentStep]);

  return (
    <div className={styles.container}>
      {currentStep.id !== DOC_VIEWER_STEPS.docs.id && (
        <div className={clsx(styles.container, styles.header)}>
          <div className={styles.titleContainer}>
            <CustomText className={clsx('h1', styles.title)}>
              Doc Viewer
            </CustomText>
            <CustomText className={styles.subtitle}>
              Access your digital thumbprint. <br /> Anytime, anywhere, always.
            </CustomText>
          </div>

          {currentStep.id !== DOC_VIEWER_STEPS.docs.id && (
            <StepCounter currentStep={currentStep} />
          )}
        </div>
      )}
      <FormProvider {...formMethods}>
        {currentStep.id === DOC_VIEWER_STEPS.mobileAndEmail.id && (
          <EnterMobileAndEmail
            setCurrentStep={setCurrentStep}
            currentStep={currentStep}
          />
        )}
        {currentStep.id === DOC_VIEWER_STEPS.verify.id && (
          <VerifySignee
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        )}
        {currentStep.id === DOC_VIEWER_STEPS.docs.id && (
          <Docs
            data={data}
            changeSort={changeSort}
            hasPrevious={hasPrevious}
            hasNext={hasNext}
            fetchPage={fetchPage}
            sort={sort}
            phone={getValues('phone')}
            isLoading={isLoading}
            count={totalCount}
          />
        )}
      </FormProvider>
    </div>
  );
};

export default DocViewer;
